import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

export const MULTIPLE_DATEPICKER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultipleDatePickerComponent),
  multi: true
};

@Component({
  selector: 'multiple-date-picker',
  template: `
    <div class="multiple-date-picker">
      <div class="picker-top-row" [ngSwitch]="arrow">
        <div class="text-center picker-navigate picker-navigate-left-arrow" id="button" [ngClass]="{'disabled':disableBackButton}" (click)="changeMonth($event, disableBackButton, -1)">
          <p *ngSwitchDefault>&lt;</p>
          <p *ngSwitchCase="1"><i class="material-icons">keyboard_arrow_left</i></p>
          <p *ngSwitchCase="2"><i class="fa fa-angle-left" aria-hidden="true"></i></p>
        </div>
        <div class="text-center picker-month">
          {{monthToDisplay}}
          <span *ngIf="yearsForSelect.length < 2">{{yearToDisplay}}</span>
        </div>
        <div class="text-center picker-navigate picker-navigate-right-arrow" [ngClass]="{'disabled':disableNextButton}" (click)="changeMonth($event, disableNextButton, 1)">
          <p *ngSwitchDefault>&gt;</p>
          <p *ngSwitchCase="1"><i class="material-icons">keyboard_arrow_right</i></p>
          <p *ngSwitchCase="2"><i class="fa fa-angle-right" aria-hidden="true"></i></p>
        </div>
      </div>
      <div class="picker-days-week-row">
        <div class="text-center" *ngFor="let weekDays of daysOfWeek">{{weekDays}}</div>
      </div>
      <div class="picker-days-row">
        <div class="text-center picker-day {{getDayClasses(day)}}" title="{{day.title}}" *ngFor="let day of days" (click)="toggleDay($event, day)">
          {{day ? day.mdp.otherMonth && !showDaysOfSurroundingMonths ? ' ' : day.date.format('D') : ''}}
        </div>
      </div>
    </div>
  `,
  styles: [`
    .text-center { text-align: center }
    .multiple-date-picker { -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none }
    .multiple-date-picker,.picker-days-row,.picker-days-week-row,.picker-top-row { width: 100%; color: #999; font-size: 10.5px; font-weight: 400 }
    .picker-top-row{ padding-top: 0 !important; text-align: center }
    .picker-top-row>div { display: inline-block }
    .picker-navigate { width: 16.5% }
    .picker-navigate p{ margin-bottom: 0; color: #5f5f5f; font-size: 17px; font-weight: 600 }
    .picker-navigate:hover { cursor: pointer }
    .picker-navigate.disabled,.picker-navigate.disabled:hover { color: #ddd; cursor: default; visibility: hidden }
    .picker-month { width: 160px; font-size: 16px; font-weight: bold; color: #000; font-family: 'Montserrat-Bold' }
    .picker-days-week-row>div{ font-weight: bold; font-size: 14px; color: #333333; font-family: 'Montserrat-Bold' }
    .picker-days-week-row{ padding: 10px 0 }
    .picker-days-row>div,.picker-days-week-row>div { width: 14.28%; display: inline-block }
    .multiple-date-picker .past{ position: relative; z-index:-1; color:#bdbdbd }
    .picker-day,.picker-top-row { padding: 10px 0 }
    .picker-day { background-color: #fff; box-sizing: border-box; color: #000; font-size: 14px; font-weight: 400; margin: 1px 0; padding: 8px 0; border: none; cursor:pointer }
    .picker-day.today.picker-off,.picker-day.today.picker-selected{ color: #fff }
    @media (min-width: 768px) { .picker-day.today.picker-off:hover, .picker-day.today:hover { color: #fff } }
    @media (min-width: 768px) { .picker-day:not(.picker-off):not(.picker-empty):hover { background-image: url(/assets/images/calender-bg-blue-large.png); color: #fff !important; background-color: #fff; background-repeat: no-repeat; background-attachment: inherit; background-position: center } }
    .picker-day.picker-selected { background-image: url(/assets/images/calender-bg-blue-large.png); color: #fff !important; background-color: #fff; background-repeat: no-repeat; background-attachment: inherit; background-position: center }
    .picker-day.picker-selected.middle-range{ background-color: #e1f8f9 !important; color: #000 !important; background-image: none }
    .picker-day.picker-selected.checkin-date{ background-image: url(/assets/images/bg-right-large.png) }
    .picker-day.picker-selected.checkout-date{ background-image: url(/assets/images/bg-left-large.png) }
    .picker-day.picker-selected.click-selection-active:not(.picker-off) { background-color: #d0d425; color: #568eab }
    .picker-day.picker-off,.picker-day.picker-off:hover { background-color: #fff; color: #bbb; cursor: default }
    .picker-day.picker-empty,.picker-day.picker-empty:hover { background-color: #fff; cursor: default; background-image: none }
    .picker-day.stay-dates { background-color: #78BC42; color: #fff }
    .picker-day.stay-dates.picker-selected { background-color: #d0d425; color: #568eab }
    .picker-day.today.stay-dates { background-color: #00a5ce; color: #f7fb65 }
    .picker-day.today.stay-dates.picker-selected { background-color: #d0d425; color: #568eab }
    .picker-day.stay-dates.picker-off { background-color: rgba(91, 136, 56, 0.6); color: rgba(255, 255, 255, 0.6) }
    .picker-day.stay-dates:not(.picker-off):hover{ background-color: rgba(0, 165, 206, 0.5); color: #f7fb65 }
    .picker-day.stay-dates.picker-selected.click-selection-active:not(.picker-off) { background-color: #d0d425; color: #568eab }
    input { border: 0; border-radius: 3px; height: 30px; max-width: 100px; text-align: center }
    .picker-day.picker-empty.picker-selected.middle-range { background-color: #fff !important }
  `],
  providers: [MULTIPLE_DATEPICKER_VALUE_ACCESSOR],
  standalone: false
})
export class MultipleDatePickerComponent implements OnInit, ControlValueAccessor {
  @Input() listingId: any;
  @Input() selectedDays: Array<any> = [];
  @Input() highlightDays: Array<any> = [];
  @Input() dayClick: any;
  @Input() dayHover: any;
  @Input() rightClick: any;
  @Input() monthChanged: any;
  @Input() fontAwesome: any;
  @Input() matIcons: any;
  @Input() monthClick: any;
  @Input() weekDaysOff: Array<any> = [];
  @Input() allDaysOff: any;
  @Input() daysAllowed: any;
  @Input() disableNavigation: any;
  @Input() disallowBackPastMonths: any;
  @Input() disallowGoFuturMonths: any;
  @Input() showDaysOfSurroundingMonths: any;
  @Input() cssDaysOfSurroundingMonths: any = 'picker-empty';
  @Input() fireEventsForDaysOfSurroundingMonths: any;
  @Input() disableDaysBefore: any;
  @Input() disableDaysAfter: any;
  @Input() changeYearPast: any;
  @Input() changeYearFuture: any;
  arrow: number = 0;
  monthAdjustment: any;
  @Input() month = moment().startOf('day');
  @Input() projectScope: Array<any> = [];
  days: Array<any> = [];
  daysOff: any = [];
  disableBackButton: any = false;
  disableNextButton: any = false;
  daysOfWeek: Array<any> = [];
  yearsForSelect: any = [];
  monthToDisplay: any;
  yearToDisplay: any;
  @Input() sundayFirstDay: any;

  constructor() {}

  ngOnInit(): void {
    if (this.month === undefined) {
      this.month = moment().startOf('day');
    }
    this.generate();
    this.daysOfWeek = this.getDaysOfWeek();
    this.arrowSelected();
    this.weekDaysOff = this.weekDaysOff || [];
  }

  arrowSelected() {
    if (this.matIcons) return this.arrow = 1;
    if (this.fontAwesome) return this.arrow = 2;
    return this.arrow;
  }

  writeValue(value: any[]) {
    if (value !== undefined) {
      this.projectScope = value;
      if (value !== null) {
        this.projectScope = this.projectScope.map((val: Date) => moment(val));
        this.projectScope.forEach((val: Date) => {
          this.days.forEach((d) => {
            if (d.date.isSame(val)) { d.mdp.selected = true; }
          });
        });
      }
    }
  }
  propagateChange = (_: any) => {};
  registerOnChange(fn: any) { this.propagateChange = fn; }
  registerOnTouched() {}

  @Input() _projectScope: any[] = [];
  get projectScope2() { return this._projectScope; }
  set projectScope2(val) { this._projectScope = val; this.propagateChange(this._projectScope); }

  checkNavigationButtons() {
    const today = moment();
    const previousMonth = moment(this.month).subtract(1, 'month');
    const nextMonth = moment(this.month).add(1, 'month');
    this.disableBackButton = this.disableNavigation || (this.disallowBackPastMonths && today.isAfter(previousMonth, 'month'));
    this.disableNextButton = this.disableNavigation || (this.disallowGoFuturMonths && today.isBefore(nextMonth, 'month'));
  }

  getDaysOfWeek() {
    const momentDaysOfWeek = moment().localeData().weekdaysMin();
    const daysOfWeek = [];
    for (let i = 1; i < 7; i++) daysOfWeek.push(momentDaysOfWeek[i]);
    if (this.sundayFirstDay) daysOfWeek.splice(0, 0, momentDaysOfWeek[0]);
    else daysOfWeek.push(momentDaysOfWeek[0]);
    return daysOfWeek;
  }

  getMonthYearToDisplay() {
    const month = this.month.format('MMMM');
    return month.charAt(0).toUpperCase() + month.slice(1);
  }

  getYearsForSelect() {
    const now = moment();
    const changeYearPast = Math.max(0, parseInt(this.changeYearPast, 10) || 0);
    const changeYearFuture = Math.max(0, parseInt(this.changeYearFuture, 10) || 0);
    const min = moment(this.month).subtract(changeYearPast, 'year');
    const max = moment(this.month).add(changeYearFuture, 'year');
    const result = [];
    const maxAdd = moment(max).add(1, 'year');
    for (let m = moment(min); maxAdd.isAfter(m, 'year'); m.add(1, 'year')) {
      if ((!this.disallowBackPastMonths || m.isAfter(now, 'year') || m.isSame(now, 'year')) && (!this.disallowGoFuturMonths || m.isBefore(now, 'year') || m.isSame(now, 'year'))) {
        result.push(m.format('YYYY'));
      }
    }
    return result;
  }

  toggleDay(event: any, day: any) {
    event.preventDefault();
    if (day.mdp.otherMonth && !this.fireEventsForDaysOfSurroundingMonths) return;
    let prevented = false;
    event.preventDefault = () => { prevented = true; };
    if (typeof this.dayClick === 'function') {
      this.projectScope = [day.date];
      this.generate();
      this.dayClick(event, day);
    }
    if (day.selectable && !prevented) {
      day.mdp.selected = !day.mdp.selected;
      if (day.mdp.selected) this.projectScope.push(day.date);
      else {
        const idx = this.projectScope.findIndex((d: any) => (moment.isMoment(d) ? d.isSame(day.date, 'day') : d.date?.isSame(day.date, 'day')));
        if (idx !== -1) this.projectScope.splice(idx, 1);
      }
    }
    this.propagateChange(this.projectScope);
  }

  clearDays() { this.projectScope = []; this.generate(); }

  runGenerate() { this.generate(); }

  rightClicked(event: any, day: any) {
    if (typeof this.rightClick === 'function') { event.preventDefault(); this.rightClick(event, day); }
  }

  getDayClasses(day: any) {
    let css = '';
    if (day.css && (!day.mdp.otherMonth || this.showDaysOfSurroundingMonths)) css += ' ' + day.css;
    if (this.cssDaysOfSurroundingMonths && day.mdp.otherMonth) css += ' ' + this.cssDaysOfSurroundingMonths;
    if (day.mdp.selected) css += ' picker-selected';
    if (day.mdp.cssclass !== '') css += ' ' + day.mdp.cssclass;
    if (!day.selectable) css += ' picker-off';
    if (day.mdp.today) {
      if (this.highlightDays?.length > 0) {
        const arrayObject = this.highlightDays.find((hd: any) => hd.date && moment(hd.date).startOf('day').isSame(moment(day.date).startOf('day')));
        css += arrayObject ? ' today ' + arrayObject.css : ' today ';
      } else css += ' today ';
    }
    if (day.mdp.past) css += ' past';
    if (day.mdp.future) css += ' future';
    if (day.mdp.otherMonth) css += ' picker-other-month';
    return css;
  }

  changeMonth(event: any, disable: any, add: number) {
    if (disable) return;
    event.preventDefault();
    let prevented = false;
    event.preventDefault = () => { prevented = true; };
    const monthTo = moment(this.month).add(add, 'month');
    if (typeof this.monthClick === 'function') this.monthClick(event, monthTo);
    if (!prevented) {
      const oldMonth = moment(this.month);
      this.month = monthTo;
      if (typeof this.monthChanged === 'function') this.monthChanged(this.month, oldMonth);
      this.generate();
    }
  }

  changeYear(year: string) { this.month = this.month.year(parseInt(year, 10)); }

  isDayOff(day: any) {
    return this.allDaysOff ||
      (this.disableDaysBefore && moment(day.date).isBefore(moment(), 'day')) ||
      (!!this.disableDaysAfter && moment(day.date).isAfter(moment(), 'day')) ||
      (Array.isArray(this.weekDaysOff) && this.weekDaysOff.some((dayOff: number) => day.date.day() === dayOff)) ||
      (Array.isArray(this.daysOff) && this.daysOff.some((dayOff: any) => day.date.isSame(dayOff, 'day'))) ||
      (Array.isArray(this.daysAllowed) && !this.daysAllowed.some((dayAllowed: any) => day.date.isSame(dayAllowed, 'day'))) ||
      (Array.isArray(this.highlightDays) && this.highlightDays.some((hd: any) => day.date.isSame(hd.date, 'day') && !hd.selectable && hd.css));
  }

  isSelected(day: any) {
    return this.projectScope.some((d: any) => day.date.isSame(moment.isMoment(d) ? d : d.date, 'day'));
  }

  isSelectedDate(day: any) {
    return this.selectedDays?.some((d: any) => day.date.isSame(moment.isMoment(d) ? d : d?.date, 'day')) ?? false;
  }

  generate() {
    this.yearsForSelect = this.getYearsForSelect();
    this.monthToDisplay = this.getMonthYearToDisplay();
    this.yearToDisplay = this.month.format('YYYY');
    let previousDay = moment(this.month).date(0).day(this.sundayFirstDay ? 0 : 1).subtract(1, 'day');
    if (moment(this.month).date(0).diff(previousDay, 'day') > 6) previousDay = previousDay.add(1, 'week');
    const firstDayOfMonth = moment(this.month).date(1);
    const days: any[] = [];
    const now = moment();
    const lastDay = moment(firstDayOfMonth).endOf('month');
    const createDate = () => {
      const day: any = {
        selectable: true,
        date: moment(previousDay.add(1, 'day')),
        css: null,
        title: '',
        mdp: { selected: false, today: false, past: true, future: true, otherMonth: false, cssclass: '' },
        slot: { dayCapacity: 0, dayAvailable: 0, dayBooked: 0, dailyRate: 0, venues: [] }
      };
      if (Array.isArray(this.highlightDays)) {
        const hlDay = this.highlightDays.filter((d: any) => day.date.isSame(d.date, 'day'));
        day.css = hlDay.length > 0 ? hlDay[0].css : '';
        day.title = hlDay.length > 0 ? hlDay[0].title : '';
        day.slot.dailyRate = hlDay.length > 0 ? hlDay[0].slot?.dailyRate : 0;
        day.slot.dayCapacity = hlDay.length > 0 ? hlDay[0].slot?.dayCapacity : 0;
        day.slot.dayAvailable = hlDay.length > 0 ? hlDay[0].slot?.dayAvailable : 0;
        day.slot.dayBooked = hlDay.length > 0 ? hlDay[0].slot?.dayBooked : 0;
        day.slot.venues = hlDay.length > 0 ? hlDay[0].slot?.venues : [];
      }
      day.selectable = !this.isDayOff(day);
      day.mdp.selected = this.isSelected(day);
      day.mdp.today = day.date.isSame(now, 'day');
      day.mdp.past = day.date.isBefore(now, 'day');
      day.mdp.future = day.date.isAfter(now, 'day');
      day.mdp.cssclass = '';
      if (!day.date.isSame(this.month, 'month')) day.mdp.otherMonth = true;
      return day;
    };
    let maxDays = lastDay.diff(previousDay, 'days');
    const lastDayOfWeek = this.sundayFirstDay ? 6 : 0;
    if (lastDay.day() !== lastDayOfWeek) maxDays += (this.sundayFirstDay ? 6 : 7) - lastDay.day();
    for (let j = 0; j < maxDays; j++) days.push(createDate());
    for (let a = 0; a < maxDays; a++) {
      days[a].mdp.selected = this.isSelectedDate(days[a]);
      days[a].mdp.cssclass = this.getRangeClass(days[a]);
      days[a].mdp.cssclass += (days[a].slot?.venues?.length > 0) ? ' has-events' : '';
    }
    this.days = days;
    this.checkNavigationButtons();
    this.propagateChange(this.projectScope);
  }

  getRangeClass(day: any) {
    if (!this.selectedDays?.length) return '';
    const x = this.selectedDays.findIndex((d: any) => day.date.isSame(moment.isMoment(d) ? d : d?.date, 'day'));
    if (x === 0 && this.selectedDays.length === 1) return 'picker-selected';
    if (x === 0) return 'checkin-date';
    if (x === this.selectedDays.length - 1) return 'checkout-date';
    return 'middle-range';
  }
}
